<div
  [ngClass]="{ field: !flat, 'flat-field': flat, 'field_with-bottom-message': displayedBottomMessage }"
  [attr.test-id]="testId"
>
  <div [ngClass]="{ field__label: !flat, 'flat-field__label': flat }">
    {{ label }}
    <ng-container *ngIf="flat">:</ng-container>
  </div>
  <ng-container *ngIf="text !== undefined">
    <div *ngIf="!ref.innerHTML.trim()" [ngClass]="{ field__text: !flat, 'flat-field__text': flat }">
      <ng-container [ngSwitch]="true">
        <span *ngSwitchCase="cropTextNeeded" cropText>
          {{ text | emptyToNotAvailable }}
        </span>
        <span *ngSwitchDefault>
          {{ text | emptyToNotAvailable }}
        </span>
      </ng-container>
      <ng-content select="[postfix]"></ng-content>
    </div>
  </ng-container>
  <ng-container *ngIf="localDate !== undefined">
    <ui-date-with-timezone [localDate]="localDate"></ui-date-with-timezone>
  </ng-container>
  <span #ref><ng-content></ng-content></span>
</div>
